export const ACCEPTED_AVATAR_FILE_FORMATS_REGEX = /image\/(?:png|jpeg|jpg|jfif|pjpeg|pjp|webp)/;
